import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  removeConfirmationTitle: string;
  removeConfirmationMessage: string;
  onRemove: () => void;
}

const RemoveConfirmationDialog: React.FC<Props> = ({
  isOpen,
  toggle,
  removeConfirmationTitle,
  removeConfirmationMessage,
  onRemove,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Confirm {removeConfirmationTitle}
      </ModalHeader>
      <ModalBody>{removeConfirmationMessage}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>{' '}
        <Button color="primary" onClick={onRemove}>
          {removeConfirmationTitle}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RemoveConfirmationDialog;
